import * as React from "react";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

/** 큰 모달 액션 버튼 라벨 타이포 (border/solid 공통) */
export const largeModalButtonLabelClassName =
  "font-pretendard text-[16px] font-semibold";

const largeBorderClassName =
  "flex h-[60px] w-[194px] items-center justify-center rounded-full border-2 border-[#0E59C6] bg-white px-12 py-3 text-[#0E59C6] hover:bg-gray-50";

export type LargeBorderButtonProps = React.ComponentProps<typeof Button>;

/** 194×60, 파란 테두리 pill — 취소·닫기 등 보조 액션용 */
export function LargeBorderButton({
  className,
  type = "button",
  variant = "outline",
  ...props
}: LargeBorderButtonProps) {
  return (
    <Button
      type={type}
      variant={variant}
      className={cn(largeBorderClassName, className)}
      {...props}
    />
  );
}

export type LargeSolidButtonProps = React.ComponentProps<typeof Button>;

/** 194×60, 파란 채움 pill — 저장·확인 등 주 액션용 */
export function LargeSolidButton({
  className,
  type = "button",
  variant = "default",
  ...props
}: LargeSolidButtonProps) {
  return (
    <Button
      type={type}
      variant={variant}
      className={cn(
        "flex h-[60px] w-[194px] items-center justify-center rounded-full bg-sig px-12 py-3 text-background hover:bg-sig/90",
        className
      )}
      {...props}
    />
  );
}
